<div class="detail-display-container" *ngIf="this.product.productVariants != null">
    <!--------------------------------------------------------------->
    <app-detail-display-variant-version-selector *ngIf="this.product != null" [product]="product" [dataType]="'PRODUCT'"
        (onVersionChosen)="onVersionSelected($event)" style="display: none;">
    </app-detail-display-variant-version-selector>
    <!--------------------------------------------------------------->
    <!-- <div
        class="desc"
        *ngIf="version && version.description && version.description?.length > 0"
        [ngClass]="{ hidden: !this.showComplete }"
        [innerHTML]="this.version.description"
    ></div> -->

    <div>
        <br />
        <div class="dis-flex-container">
            <h3 style="margin-bottom: 1rem">Produkttypen</h3>
            <mat-icon matSuffix class="info-icon"
                matTooltip="Angezeigt werden die Produkttypen aus der neuesten Version der ausgewählten Variante."
                matTooltipPosition="above" tabindex="-1">
                info_outline
            </mat-icon>
            <!-- <mat-slide-toggle
                class="example-margin"
                color="accent"
                [checked]="ptgToggle"
                (change)="ptgToggle = !ptgToggle"
            ></mat-slide-toggle> -->
        </div>
        <!-- <h5 style="font-style: italic">
            Zugeordnete Produktkategorien für diese Produktversion
        </h5> -->
        <div>
            <div class="chip-set" aria-label="Angegebene Produkttypen">
                @for (ptgVersionFeature of displayedPtgs; track $index) {
                    <button class="btn-chip" (click)="scrollToComparison()"
                    >
                            <div class="certificate-container" matChipAvatar>
                                @if (ptgVersionFeature.isCertified) {
                                    <div matTooltip="Dieser Produkttyp wurde von einer unabhängigen Stelle zertifiziert."
                                        [matTooltipPosition]="'above'" class="cert-image"
                                        [ngStyle]="{ 'background-image': 'url(/assets/svg-icons/certification.svg)' }">
                                    </div>
                                } @else if (ptgVersionFeature.doesProjectFulfillAllFeaturesOfPTGVersion) {
                                    <div matTooltip="Gemäß Anbieter erfüllt dieses Produkt alle Funktionen die für den Anwendungsbereich (Produkttyp) verpflichtend notwendig sind.">
                                        <mat-icon class="green-confirm">check</mat-icon>
                                    </div>
                                }
                            </div>
                        {{ ptgVersionFeature.ptgName }}
                    </button>
                }
                <div *ngIf="displayedPtgs.length === 0" class="no-data-message">
                    <em>Keine Produkttypen angegeben</em>
                </div>
            </div>
            <br />
            <mat-divider></mat-divider>
            <br />
        </div>

        <div class="twocolumnsgrid">
            <h3 style="margin-bottom: 1rem">Stärken des Produktes</h3>
            <!-- <mat-slide-toggle
                class="example-margin"
                color="accent"
                (change)="productFeatureToggle = !productFeatureToggle"
                [checked]="productFeatureToggle"
            ></mat-slide-toggle> -->
        </div>
        <!-- <h5 style="font-style: italic">
            Vom Produktanbieter definierte Produkteigenschaften
        </h5> -->
        <div #productFeatureList>
            <div class="features-list">
                <div *ngFor="let productFeature of displayedFetures" class="feature-item">
                    <span> {{ productFeature }} </span>
                    <!-- <h5 style="font-style: italic">
                        /
                    </h5>   -->
                </div>

                <div *ngIf="displayedFetures.length === 0" class="no-data-message">
                    <em>Keine Stärken angegeben</em>
                </div>

            </div>
            <br />
            <mat-divider></mat-divider>
            <br />
        </div>
    </div>
    <div>
        <div class="twocolumnsgrid">
            <h3 style="margin-bottom: 0.5rem" #comparisonSection>Funktionen und Features</h3>
            <!-- <mat-slide-toggle
                class="example-margin"
                color="accent"
                (change)="attributeToggle = !attributeToggle"
                [checked]="attributeToggle"
            ></mat-slide-toggle> -->
        </div>
        <!-- <h5 style="font-style: italic">
            Von den BIMSWARM-Fachgruppen vorgegebene Produkteigenschaften
        </h5> -->
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [(selectedIndex)]="selectedComparisonTabIndex">
            <mat-tab>
                <ng-template mat-tab-label>
                    <span>VARIANTEN VERGLEICH &nbsp;</span>
                    <mat-icon matSuffix class="info-icon"
                        matTooltip="Es kann mehrere Varianten für ein Produkt geben. Sie werden verwendet bei unterschiedlichen Produktausführungen für die gleiche Zielgruppe und unterscheiden sich z.b. in Preis und Funktionsumfang. Im Variantenvergleich werden die Produkttypen der neuesten Version verglichen."
                        tabindex="-1">
                        info_outline
                    </mat-icon>
                </ng-template>
            </mat-tab>
            <mat-tab
                [disabled]="!variantsListFiltered || variantsListFiltered.length === 0 || variantsListFiltered[0]?.variantVersions?.length <= 1">
                <ng-template mat-tab-label>
                    <span
                        *ngIf="!variantsListFiltered || variantsListFiltered.length === 0 || variantsListFiltered[0]?.variantVersions?.length <= 1; else enabledVersionTab"
                        class="pointer-shown"
                        matTooltip="Nur eine Version vorhanden"
                        [matTooltipPosition]="'above'">
                        VERSIONEN VERGLEICH
                    </span>
                    <ng-template #enabledVersionTab>
                        <span>VERSIONEN VERGLEICH</span>
                    </ng-template>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
        <div *ngIf="!loading" class="tab-container">
            <ng-container *ngIf="selectedComparisonTabIndex === 1">
                <app-product-type-group-feature-display *ngIf="variantsListFiltered && variantsListFiltered.length"
                    [variantsList]="variantsListFiltered" [key]="variantsList[0]?.id"
                    [comparisonMode]="'version'"></app-product-type-group-feature-display>
            </ng-container>

            <ng-container *ngIf="selectedComparisonTabIndex === 0">
                <app-product-type-group-feature-display *ngIf="variantsList && variantsList.length"
                    [selectedVariantId]="variantsListFiltered[0]?.id" [variantPTGFeaturesList]="variantsList"
                    [comparisonMode]="'variant'"></app-product-type-group-feature-display>
            </ng-container>
            <br />
            <mat-divider></mat-divider>
            <br />
        </div>
        <div class="twocolumnsgrid">
            <h3 class="mg-btm">Übergeordnete Auswahlkriterien</h3>
            <!-- <mat-slide-toggle
                class="example-margin"
                color="accent"
                (change)="commonFeaturesToggle = !commonFeaturesToggle"
                [checked]="commonFeaturesToggle"
            ></mat-slide-toggle> -->
        </div>
        <!-- <h5 style="font-style: italic">
            Von BIMSWARM vorgegebene Produkteigenschaften
        </h5> -->
        <div>
            <app-product-detail-display-common-features
                *ngIf="productCommonFeatures && productCommonFeatures.length > 0"
                [commonFeatures]="productCommonFeatures"></app-product-detail-display-common-features>
            <div *ngIf="!productCommonFeatures || productCommonFeatures.length === 0" class="no-data-message">
                <em>Keine übergeordneten Auswahlkriterien verfügbar</em>
            </div>
        </div>
    </div>
</div>
